export default {
    formConfigurations: {},
    formConfigurationsByType: {},

    formConfigurationMeasures: []
}
